<form [formGroup]="mainForm" (ngSubmit)="onSubmit()">
  <lgd-password controlName="newPassword" label="New password" autocomplete="new-password">
  </lgd-password>

  <lgd-password controlName="newPasswordConfirm" label="Confirm password" autocomplete="new-password">
  </lgd-password>

  <div fxLayout="column" fxLayoutAlign="space-between center" class="login-button-container tt-margin--top">
    <forge-button fxFlex type="submit" variant="raised" [disabled]="mainForm.invalid"
      telemetry="Submission-ResetPassword">
      Reset password
    </forge-button>

    <forge-button fxFlex (click)="onCancel()" telemetry="Submission-PasswordResetCancel">
      Return to sign in
    </forge-button>
  </div>

  <div fxLayout="row" fxLayoutAlign="center center" class="tt-margin--top tt-margin--bottom">
    @if (mainForm.invalid) {
      <div class="error-text forge-typography--subheading1">
        @if (mainForm.hasError('diff')) {
          New password cannot be the same as current password.
        }
        @if (error) {
          {{error}}
        }
      </div>
    }
  </div>
</form>

<ng-template #successMessage>
  <div>Success! Your password has been changed.</div>

  <mat-dialog-actions>
    <button mat-dialog-close>
      OK
    </button>
  </mat-dialog-actions>
</ng-template>
